import { render, staticRenderFns } from "./VeJwCJClassList.vue?vue&type=template&id=268836a5&scoped=true"
import script from "./VeJwCJClassList.vue?vue&type=script&lang=js"
export * from "./VeJwCJClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268836a5",
  null
  
)

export default component.exports